import { render, staticRenderFns } from "./organisation-info.vue?vue&type=template&id=d02c8946&scoped=true"
import script from "./organisation-info.vue?vue&type=script&lang=ts"
export * from "./organisation-info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d02c8946",
  null
  
)

export default component.exports